{
  "communicationError": {
    "cancel": {},
    "tryAgain": {}
  },
  "node": {
    "useNode": {},
    "nodeList": {}
  },
  "nodeFooter": {
    "back": {},
    "cancel": {},
    "next": {},
    "reviewAndFinish": {}
  },
  "advanced": {
    "promoted": {},
    "constraintHandling": {},
    "constraintLifetime": {}
  },
  "advancedFooter": {
    "back": {},
    "cancel": {},
    "next": {}
  },
  "report": {},
  "review": {
    "node": {},
    "constraintHandling": {},
    "constraintLifetime": {},
    "promoted": {}
  },
  "reviewFooter": {
    "back": {},
    "cancel": {},
    "next": {}
  },
  "success": {
    "close": {}
  },
  "unsuccess": {
    "back": {},
    "cancel": {},
    "proceedAnyway": {}
  }
}
